<template>
  <data-loader>
    <full-page-modal
      :header-text="sectionTitle"
      :content-text="section.introText || 'Intro text is configured in the legacy CMS for each section'"
      :primary-button-text="primaryButtonText"
      @primary-button-click="startSection"
    >
      <template v-slot:timer>
        <span>{{ formattedTime(timeLeftInSeconds) }}</span>
      </template>
    </full-page-modal>
  </data-loader>
</template>

<script>
import FullPageModal from '@components/sims/FullPageModal';
import WuxSimulationsMixin from '@/mixins/wux-simulations';
import DataLoader from '@/components/sims/DataLoader.vue';
import AccommodationsMixin from '@/mixins/accommodations';

export default {
  components: {FullPageModal, DataLoader},
  mixins: [WuxSimulationsMixin, AccommodationsMixin],
  data() {
    return {
      timeLeftInSeconds: null,
      timerInterval: null,
    };
  },
  computed: {
    isCategoryNotStarted() {
      return this.categoryState?.categoryStatusId === this.notStartedStatus.id;
    },
    sectionTitle() {
      return `INBDE Section ${this.sectionIndex + 1} Introduction`;
    },
    primaryButtonText() {
      return `Begin Section ${this.sectionIndex + 1}`;
    },
  },
  watch: {
    timeLeftInSeconds(currentValue) {
      if (currentValue < 0 && !this.loadingData) {
        this.startSection();
      }
    },
  },
  mounted() {
    this.timerInterval = setInterval(() => {
      try {
        const introTimeInMinutes = this.userIntroTime || this.section.introTimeInMinutes;
        this.timerTick(this.isCategoryNotStarted, introTimeInMinutes);
      }
      catch(e) {
        clearInterval(this.timerInterval);
      }
    }, 250);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  },
  methods: {
    startSection() {
      this.setCategoryState(this.section, this.inProgressStatus);
      const flashcards = this.flashcardsBySection(this.sectionId);
      return this.$router.push({
        name: 'simSectionFlashcard#show',
        params: {
          simId: this.simId,
          sectionId: this.sectionId,
          flashcardId: flashcards[0].id,
        },
      });
    },
  },
};
</script>
